import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalService } from '@df/ui/modal/modal.service';
import { ModalLayoutRightComponent, NModalLayoutRight } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { Subscription } from 'rxjs';
import { BasketFreeDeliveryNoticeComponent } from '../free-shipping/basket-free-shipping.component';
import { BasketViewItemComponent } from '../view-item/basket-view-item.component';
import { BasketViewSubmitComponent } from '../view-submit/basket-view-submit.component';
import { BasketViewTotalsComponent } from '../view-totals/basket-view-totals.component';

export const BASKET_ADD_CONFIRMATION_MODAL_ID = 'basketAddConfirmationModal';

@DfModal({
    id: BASKET_ADD_CONFIRMATION_MODAL_ID,
    position: 'bottom',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName),
        modalClass: 'bg-col-w p-t-15 p-a-10 p-a-4-s p-t-7-s'
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M']
})
@Component({
    selector: 'basket-add-confirmation-modal',
    templateUrl: './basket-add-confirmation-modal.html',
    styleUrls: ['./basket-add-confirmation-modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ModalLayoutRightComponent, CommonModule, BasketViewSubmitComponent, BasketViewTotalsComponent, BasketViewItemComponent, BasketFreeDeliveryNoticeComponent]
})
export class BasketAddConfirmationModal implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    constructor(private ref: ChangeDetectorRef, private app: App, private modalService: ModalService) {}

    ngOnInit() {
        this.subscriptions.add(this.basket.subscribe(() => this.ref.detectChanges()));
    }

    get basket(): Basket {
        return this.app.customer.basket;
    }

    close() {
        this.modalService.closeAll();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    itemTrackFn(index: number, item: BasketItem): number {
        return item.id;
    }
}
